<ion-item
  *ngIf="!iconOnly"
  lines="none"
  detail="false"
  class="app-menu-item profile-appearance-item"
>
  <div class="profile-appearance-layout">
    <div class="profile-appearance-main">
      <ion-icon
        color="primary"
        *ngIf="isDarkMode$ | async; else lightIcon"
        name="moon-outline"
      ></ion-icon>

      <ng-template #lightIcon>
        <ion-icon color="primary" name="sunny-outline"></ion-icon>
      </ng-template>

      <ion-label>
        <h3>{{ "PROFILE.APPEARANCE" | translate }}</h3>
        <p>
          {{ "modesToggle.chooseMode" | translate }}
        </p>
      </ion-label>
    </div>

    <div
      class="theme-mode-control"
      data-testid="profile-dark-mode"
      role="radiogroup"
      [attr.aria-label]="'PROFILE.APPEARANCE' | translate"
      (click)="$event.stopPropagation()"
    >
      <button
        *ngFor="let mode of themeModes"
        type="button"
        class="theme-mode-option"
        [class.active]="(themeMode$ | async) === mode"
        [attr.aria-checked]="(themeMode$ | async) === mode"
        role="radio"
        (click)="setThemeMode(mode, $event)"
      >
        {{ getModeLabelKey(mode) | translate }}
      </button>
    </div>
  </div>
</ion-item>

<div
  *ngIf="iconOnly"
  class="darkmode-icon-only"
  data-testid="auth-dark-mode"
  (click)="toggleDarkMode()"
>
  <ion-icon
    *ngIf="isDarkMode$ | async; else lightIconOnly"
    name="moon-outline"
  ></ion-icon>

  <ng-template #lightIconOnly>
    <ion-icon name="sunny-outline"></ion-icon>
  </ng-template>
</div>
